import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header.tsx';
import Footer from './Footer.tsx';
import SkipLink from '../ui/SkipLink.tsx';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  
  // Check if current language is RTL
  const rtlLanguages = ['ar'];
  const isRTL = rtlLanguages.includes(currentLang);

  return (
    <div 
      className="min-h-screen flex flex-col"
      dir={isRTL ? 'rtl' : 'ltr'}
      lang={currentLang}
    >
      <SkipLink />
      <Header />
      <main id="main-content" className="flex-1" role="main">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
